module.exports = __webpack_public_path__ + "img/cash.78916073.png";